import { render, staticRenderFns } from "./AtomContentText.vue?vue&type=template&id=47287560&"
import script from "./AtomContentText.vue?vue&type=script&lang=js&"
export * from "./AtomContentText.vue?vue&type=script&lang=js&"
import style0 from "./AtomContentText.vue?vue&type=style&index=0&id=47287560&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports